module.exports = __webpack_public_path__ + "static/img/bbwlogo.c8b011a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bbwlogo.png
// module id = CKIX
// module chunks = 0